import groupByDate from "@irati/wallet/helpers/groupWalletItemsByDate";
import { LIST_SCHEDULED_TRANSFERS, CLEAR_SCHEDULED_TRANSFERS } from "../actions/ScheduledTransfer";
var defaultState = {
    results: null
};
var ScheduledTransferReducer = function (state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case LIST_SCHEDULED_TRANSFERS: {
            var existingScheduledTransfers = action.existingScheduledTransfers, newScheduledTransfers = action.newScheduledTransfers;
            return groupByDate(existingScheduledTransfers, newScheduledTransfers);
        }
        case CLEAR_SCHEDULED_TRANSFERS:
            return defaultState;
        default:
            return state;
    }
};
export default ScheduledTransferReducer;
